<template>
	<div>
		
	</div>
</template>

<script>
	let that;	
	export default{
		data(){
			return{
				
			}
		},
		props:{
			title:{
				type:String,
				default:'删除数据'
			},
			content:{
				type:String,
				default:'确定删除当前数据？'
			},
		},
		methods:{
			// 显示弹窗
			showToast(callback){
				that.$confirm(that.content, that.title, {
					cancelButtonText: '取消',
					confirmButtonText: '确定',
					type: 'warning'
				}).then(() => {
					// 确定
					callback(true)
				}).catch(() => {
					// 取消
					callback(false)
				});
			}
		},
		mounted(){
			
		},
		created() {
			that = this;
		}
	}
</script>

<style>
</style>
